import React, { Component } from 'react'
import { connect } from 'react-redux'
import Status from '../components/Status'
import Spinner from '../components/Spinner'
import { Names } from '../constants/names'
import { MAG_THRESHOLDS } from '../constants/thresholds'

interface MagChangeContainerProps {
  magnetometers: any
}

class MagChangeContainer extends Component<MagChangeContainerProps> {
  getChanges() {
    const { magnetometers } = this.props
    let changes =
      magnetometers &&
      magnetometers.periodData &&
      magnetometers.periodData.map((mag: any) => {
        return {
          ...mag.change,
          key: mag.key,
          name: Names[mag.key],
        }
      })
    if (!changes)
      // ToDo: Fix properly
      return

    return changes.map((change: any) => {
      const { key } = change
      return (
        <Status
          title={change.name}
          {...change}
          reverseThresholds={true}
          thresholds={MAG_THRESHOLDS[key]}
          unit="nT"
        />
      )
    })
  }

  getSpinner() {
    return (
      <div className="spinner-container">
        <Spinner />
      </div>
    )
  }

  render() {
    const { fetching } = this.props.magnetometers
    return (
      <div className="magnetometer-changes">
        <h3 className="headline">Magnetometer X change in last 15 minutes</h3>
        {fetching ? this.getSpinner() : <div>{this.getChanges()}</div>}
      </div>
    )
  }
}

function mapStateToProps(state: MagChangeContainerProps) {
  return {
    magnetometers: state.magnetometers,
  }
}

export default connect(mapStateToProps)(MagChangeContainer)
